import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';

const getTokenExpiration = () => {
  const token = sessionStorage.getItem('token');
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));

    const expirationRaw = payload.expiration_date; 
    if (!expirationRaw) return null;

    const parts = expirationRaw.split(':');
    const timestampStr = parts[parts.length - 1];

    const expirationDate = new Date(Number(timestampStr) * 1000);

    return expirationDate;

  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return null;
  }
};



const Dashboard = () => {
  const navigate = useNavigate();
  const [daysLeft, setDaysLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const expirationDate = getTokenExpiration();
  
    if (!expirationDate) {
      setIsExpired(true);
      setDaysLeft(0);
      return;
    }
  
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expire = new Date(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate());
  
    const diffTime = expire.getTime() - today.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
  
    if (diffDays < 0) {
      setIsExpired(true);
      setDaysLeft(0);
      return;
    }
  
    if (diffDays <= 15) {
      setIsExpired(false);
      setDaysLeft(diffDays);
      return;
    }
  
    setIsExpired(false);
    setDaysLeft(null);
  
  }, []);

  

  const handleClick = () => navigate('/coroasemfim');
  const handleClickDad = () => navigate('/denteadente');
  const handleClickConica = () => navigate('/engconica');
  const handleClickHipoide = () => navigate('/enghipoide');

  const whatsappNumber = '5514998421100'; 
  const message = encodeURIComponent(
    'Olá! Meu plano expirou e gostaria de renovar o acesso aos cálculos.'
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <>
      <Header />
      <div className="container_information">

        {/* {isExpired && (
          <div className="expired_box">
            <h2>🚫 Plano expirado!</h2>
            <p>Seu plano está vencido e os cálculos não funcionarão até ser renovado.</p>
            <div className="button_group">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp_button"
              >
                💬 Renovar via WhatsApp
              </a>
              <a
                href="https://ewersontx.kpages.online/software-renania-a044d70f-701d-4269-8b89-cb929224516d"  
                target="_blank"
                rel="noopener noreferrer"
                className="hotmart_button"
              >
                💳 Renovar via Hotmart
              </a>
            </div>
          </div>
        )}

    
        {!isExpired && daysLeft !== null && daysLeft <= 15 && (
          <div className="warning_box">
            <h2>⚠️ Atenção!</h2>
            <p>
              Seu plano expira em <strong>{daysLeft}</strong> dia
              {daysLeft > 1 ? 's' : ''}.
            </p>
            <p>Renove agora para não perder acesso aos cálculos.</p>
            <div className="button_group">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp_button"
              >
                💬 Renovar via WhatsApp
              </a>
              <a
                href="https://ewersontx.kpages.online/software-renania-a044d70f-701d-4269-8b89-cb929224516d"
                target="_blank"
                rel="noopener noreferrer"
                className="hotmart_button"
              >
                💳 Renovar via Hotmart
              </a>
            </div>
          </div>
        )} */}

        
        <div className="button_for_click" onClick={handleClickDad}>
          ENGRENAGEM PARALELA RETA OU HELICOIDAL
        </div>
        <div className="button_for_click" onClick={handleClickConica}>
          ENGRENAGEM CÔNICA RETA
        </div>
        <div className="button_for_click" onClick={handleClickHipoide}>
          ENGRENAGEM CÔNICA ESPIRAL
        </div>
        <div className="button_for_click" onClick={handleClick}>
          COROA E SEM-FIM
        </div>
      </div>
    </>
  );
};

export default Dashboard;
